import { TXImageTemplate } from "../../../types/common/templates.types";

export const X_IMAGE_TEMPLATES: TXImageTemplate = {
  "Image Par Defaut": {
    template: [
      {
        name: "XImage",
        props: {
          all: {
            src: "https://d-themes.com/wordpress/riode/demo-24/wp-content/uploads/sites/29/2020/09/product-6-2-1-600x675.jpg",
            width: "200px",
            height: "360px",
          },
        },
      },
    ],
  },
};
